import {hostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const updateClient = async (id, client) => {
  const token = localStorage.getItem("access_token");

  const result = await fetch(`${hostName}/client/${id}`, {
    method: "PUT",
    headers: {
      ...defaultHeaders,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(client),
  });

  if (!result.ok) {
    const error = await result.json();
    throw new Error(error.message || "Failed to update client");
  }

  return result.json();
};
